import { type HTMLAttributes } from 'react';
import { Check, Clock, Mail, X } from 'lucide-react';
import styles from './tag.module.css';

export type TagVariant =
  | 'accent'
  | 'speaker'
  | 'interest'
  | 'neutral'
  | 'outline'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'attended'
  | 'ended';

/**
 * Durum işareti (StatusTag kartı "İşaret" sütunu): nokta, saat, onay, çarpı,
 * zarf. Renk yalnız destektir; Onaylandı ve Reddedildi ayrıca simgeyle ayrılır.
 */
export type TagMark = 'dot' | 'clock' | 'check' | 'x' | 'mail';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  readonly variant?: TagVariant;
  readonly mark?: TagMark;
}

const MARK_ICON = { clock: Clock, check: Check, x: X, mail: Mail } as const;

/**
 * Durum etiketi (StatusTag kartı) ve ilgi çipi (`variant="interest"`, `wb-chip`).
 *
 * Köşe `radius-tag` (6 px): düğmeyle karışmasın diye hap biçimi yok. Etiket
 * kelimeyle okunur, renk yalnız destektir. Mandalina hiçbir etikette yoktur
 * (konuşmacı rolü petrol çerçeveli). Tıklanmaz.
 */
export function Tag({ variant = 'neutral', mark, className, children, ...rest }: TagProps) {
  const Icon = mark && mark !== 'dot' ? MARK_ICON[mark] : null;
  return (
    <span
      {...rest}
      className={[styles.tag, styles[variant], className ?? ''].filter(Boolean).join(' ')}
      data-tag-mark={mark}
    >
      {mark === 'dot' ? <span className={styles.dot} aria-hidden="true" /> : null}
      {Icon ? <Icon className={styles.icon} aria-hidden="true" strokeWidth={2} /> : null}
      {children}
    </span>
  );
}
